import { DateTimePicker, DateTimePickerProps } from '@mui/lab';
import { TextField } from '@mui/material';
import { DATETIME_FORMAT } from '../config/constants';
import { useError } from '../helpers/hooks';

interface IXsDateTimePickerProps extends Omit<DateTimePickerProps<Date>, 'renderInput'> {
  name: string;
  required?: boolean;
  tabIndex?: number;
}

export const XsDateTimePicker = (props: IXsDateTimePickerProps) => {
  const {
    name,
    label,
    required = false,
    tabIndex,
    inputFormat = DATETIME_FORMAT,
    mask = '__.__.____ __:__',
    ...rest
  } = props;

  const { error, helperText } = useError(name);

  return (
    <DateTimePicker
      {...rest}
      inputFormat={inputFormat}
      value={props.value ?? null}
      mask={mask}
      // label={`${label}${required ? ' *' : ''}`}
      renderInput={(params) => (
        <TextField
          {...params}
          required={required}
          InputLabelProps={{ shrink: true }}
          fullWidth
          size='small'
          label={label}
          error={error}
          helperText={helperText}
          inputProps={{
            ...params.inputProps,
            tabIndex
          }}
        />
      )}
    />
  );
};
